import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

interface RequestCandidateResumeParams {
  placementCandidateId: string;
}

export function useRequestCandidateResume(
  options: UseMutationOptions<unknown, string, RequestCandidateResumeParams> = {}
) {
  return useMutation({
    mutationFn: async (params) => {
      const { placementCandidateId } = params;

      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/placement-candidates/${placementCandidateId}/request-resume`,
        responseSchema: z.unknown(),
      });

      return response.data;
    },
    ...options,
  });
}
